export default "__VITE_ASSET__CYdrodYc__"